import type { stacks } from "@dropbox/api-v2-client";
import useDropboxAccount from "@mirage/service-auth/useDropboxAccount";
import { v4 as uuidv4 } from "uuid";
import { ActionsMenu } from "../ActionsMenu";
import { ArchiveConfirmationModal } from "../ArchiveConfirmationModal";
import { CloneConfirmationModal } from "../CloningConfirmationModal";
import { stackIsArchived } from "../Helpers/Utils";
import { useArchiveStack } from "../hooks";
import { useCloneStack } from "../hooks/useCloneStack";

export const StackSettingsMenu = ({
  mutationRequestId,
  onEdit,
  stack,
}: {
  mutationRequestId?: string;
  onEdit?: () => void;
  stack: stacks.Stack | null;
}) => {
  const currentAccount = useDropboxAccount();
  const {
    isArchiveModalOpen,
    isArchiveStacksEnabled,
    setIsArchiveModalOpen,
    toggleStackArchiveStatus,
  } = useArchiveStack(stack);
  const {
    handleCloneStack,
    isCloneStackModalOpen,
    isCloneStacksEnabled,
    isCloning,
    setIsCloneStackModalOpen,
  } = useCloneStack(stack);

  return (
    <>
      <ActionsMenu
        currentAccount={currentAccount}
        isCloning={isCloning}
        mutationRequestId={mutationRequestId}
        onArchive={() => isArchiveStacksEnabled && setIsArchiveModalOpen(true)}
        onClone={() => isCloneStacksEnabled && setIsCloneStackModalOpen(true)}
        onEdit={onEdit}
        stack={stack}
        useGearIcon
      />
      {isArchiveStacksEnabled && (
        <ArchiveConfirmationModal
          isArchived={stackIsArchived(stack)}
          isOpen={isArchiveModalOpen}
          onCancel={() => setIsArchiveModalOpen(false)}
          onConfirm={async () => {
            setIsArchiveModalOpen(false);
            await toggleStackArchiveStatus();
          }}
        />
      )}
      {isCloneStacksEnabled && (
        <CloneConfirmationModal
          isOpen={isCloneStackModalOpen}
          onCancel={() => setIsCloneStackModalOpen(false)}
          onConfirm={async () => {
            await handleCloneStack(uuidv4());
            setIsCloneStackModalOpen(false);
          }}
        />
      )}
    </>
  );
};
